import styled from 'styled-components';

import {
  MOBILE_PADDING,
  SCREEN_LOCKUP_WIDTH,
  BLACK,
  WHITE,
  PAGE_WIDTH,
  BG_GRAY,
} from '../../../styles/variables.style';
import media from '../../../styles/media.style';

const CELL_SIZE = 190;

export const Section = styled.section`
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 4em ${MOBILE_PADDING}px;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: 0 auto;
  overflow: hidden;

  ${media.tabletL`
    padding: 0 0 6em;
  `};
`;

export const SectionInner = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
`;

export const DropdownWrapper = styled.div`
  display: none;
  margin: 0 auto;
  width: 100%;
  max-width: 350px;

  ${media.tabletL`
    display: flex;
  `};
`;

export const List = styled.div`
  display: none;

  ${media.tabletL`
    display: block;
  `};
`;

export const SliderWrapper = styled.div`
  display: block;
  width: 100%;
  margin: 20px auto 0;

  & > div > div {
    width: 100%;
    overflow: visible !important;
  }

  ${media.tabletL`
    display: none;
  `};
`;

export const Item = styled.div`
  display: flex;
  color: ${WHITE};
  background-color: ${BLACK};
  min-height: ${CELL_SIZE}px;
  margin-bottom: 1em;
  padding: 20px 10%;

  > a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  > h2 {
    margin: 0 0 20px;
    font-size: 26px;
    line-height: 1.1em;
    letter-spacing: 1px;
    max-width: 354px;

    > span {
      text-transform: uppercase;
    }

    ${media.tabletL`
      font-size: 38px;
    `};
  }

  > p {
    font-size: 14px;
    line-height: 1.5em;
    letter-spacing: 0.5px;
    flex: 1;
    max-width: 354px;
    margin: 0;

    > span {
      font-weight: 400;
    }

    ${media.tabletL`
      font-size: 16px;
      line-height: 1.1em;
    `};
  }
`;

export const SeminarTitle = styled.h4`
  font-weight: 400;
  font-size: 26px;
  text-transform: uppercase;
  margin: 0 0 1em;
  max-width: 230px;
  color: white;

  ${media.tabletL`
    font-size: 29px;
    margin: 0;
  `};
`;

export const Keys = styled.div`
  flex: 1;
  margin-right: 2.5em;

  p {
    margin: 0;
    font-size: 14px;

    :last-child {
      line-height: 1em;
    }

    ${media.tabletL`
      font-size: 18px;
    `};

    :not(:last-child) {
      margin: 0 0 0.6em;
    }
  }
`;

export const Values = styled.div`
  flex: 3;

  p {
    margin: 0;
    font-size: 14px;

    :last-child {
      line-height: 1em;
    }

    ${media.tabletL`
      font-size: 18px;
    `};

    :not(:last-child) {
      margin: 0 0 0.6em;
    }
  }
`;

export const PlaceholderWrapper = styled.div`
  position: relative;
  flex: 1;
  margin-bottom: 45px;

  :not(:last-child) {
    margin-right: 10px;
  }
`;

export const Title = styled.h5`
  color: ${BLACK};
  letter-spacing: 0.1em;
  margin: 0;
  padding-bottom: 60px;
  position: relative;
  text-align: center;
  text-transform: uppercase;

  &::after {
    content: '';
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BLACK};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin-bottom: 35px;
  `};
`;

export const SeminarListHeader = styled.div`
  display: flex;
  background-color: ${BG_GRAY.COMMON_1};
  padding: 0 10%;
  margin: 45px 0 1em;

  a {
    padding: 0;
    text-align: right;
    margin-left: 50%;

    span {
      text-transform: uppercase;
      font-weight: 800;
      text-decoration: underline;
      font-size: 13px;
      line-height: 1em;
      letter-spacing: 1px;
    }
  }
`;

export const LinkWrapper = styled.div`
  display: inline-flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
`;

export const Address = styled.p`
  flex: 3;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 700px;
  font-size: 18px;
  line-height: 60px;
  margin: 0;
`;

export const SeminarLink = styled.div`
  margin-top: 25px;

  > span {
    text-transform: uppercase;
    text-decoration: underline;
    font-weight: 800;
    font-size: 13px;
    letter-spacing: 1px;
  }

  ${media.tabletL`
    margin-top: 0;
    text-align: right;
  `};
`;

export const ItemContent = styled.div`
  padding: 40px 20px;
  width: 100%;

  ${media.tabletL`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 0;

    > div {
      flex: 2;

      :last-child {
        flex: 1;
      }
    }
  `};
`;

export const Info = styled.div`
  display: flex;
`;

export const InfoLabel = styled.p`
  flex-shrink: 0;
  padding-right: 10px;
  width: 100px;
`;

export const InfoList = styled.div``;

export const MobileDropdownWrapper = styled.div`
  display: block;

  ${media.tabletL`
    display: none;
  `};
`;

export const FilterBtn = styled.button`
  cursor: pointer;
  position: relative;
  background-color: ${BLACK};
  border: none;
  font-size: 16px;
  font-weight: 800;
  height: 57px;
  padding: 0 20px;
  line-height: 57px;
  text-transform: uppercase;
  color: ${WHITE};
  width: 100%;
  text-align: left;
  letter-spacing: 1px;

  ${media.tabletL`
    height: 85px;
    line-height: 85px;
    padding: 0 40px;
  `};

  span {
    margin-right: 50px;
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 1px;

    ${media.tabletL`
      font-size: 16px;
    `};
  }

  ::after {
    content: '';
    position: absolute;
    top: 42%;
    right: 20px;
    transform: translateY(-50%) rotate(-45deg);
    width: 6px;
    height: 6px;
    border-top: 2px solid ${WHITE};
    border-right: 2px solid ${WHITE};

    ${media.tabletL`
      right: 40px;
    `};
  }

  ::before {
    content: '';
    position: absolute;
    top: 58%;
    right: 20px;
    transform: translateY(-50%) rotate(135deg);
    width: 6px;
    height: 6px;
    border-top: 2px solid ${WHITE};
    border-right: 2px solid ${WHITE};

    ${media.tabletL`
      right: 40px;
    `};
  }
`;

export const FilterMenuWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${WHITE};
  z-index: 999999999;
  padding: 22px 0;
`;

export const CloseBtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 ${MOBILE_PADDING}px;
`;

export const CloseBtn = styled.button`
  cursor: pointer;
  background: transparent;
  border: none;
  margin-bottom: 1em;
  padding: 0;
`;

export const FilterTypeList = styled.div`
  overflow: auto;
  flex: 1;
`;

export const FiltersWrapper = styled.div`
  padding: 15px 0;
  background-color: ${BG_GRAY.COMMON_1};
`;

export const FilterItem = styled.button`
  height: 45px;
  cursor: pointer;
  color: ${BLACK};
  width: 100%;
  text-align: left;
  border: none;
  padding: 0 30px;
  font-size: 14px;
  text-transform: uppercase;
  background-color: ${BG_GRAY.COMMON_1};

  span {
    vertical-align: middle;
    letter-spacing: 1px;
  }

  > span:first-child {
    background-color: ${({ selected }) => (selected ? BLACK : WHITE)};
  }

  :hover {
    > span:first-child {
      background-color: ${({ selected }) => (selected ? BLACK : BG_GRAY.COMMON_3)};
    }
  }
`;

export const Checkmark = styled.span`
  display: inline-block;
  position: relative;
  width: 25px;
  height: 25px;
  border: 1px solid ${BLACK};
  margin-right: 12px;
  border-radius: 50%;

  ::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%) rotate(-45deg);
    border-bottom: 1px solid ${WHITE};
    border-left: 1px solid ${WHITE};
    width: 8px;
    height: 4px;
  }
`;

export const FilterButtonWrapper = styled.div`
  padding: 0 ${MOBILE_PADDING}px;
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
`;

export const ClearBtn = styled.button`
  height: 45px;
  line-height: 45px;
  background-color: ${WHITE};
  border: 1px solid ${BLACK};
  flex: 1;
  text-align: center;
  margin-right: 8px;

  span {
    text-transform: uppercase;
    font-weight: 800;
    font-size: 12px;
    letter-spacing: 1px;
  }
`;

export const ApplyBtn = ClearBtn.extend`
  background-color: ${BLACK};
  color: ${WHITE};
  margin-right: 0;
`;

export const NonLinkWrapper = styled.div`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/UpcomingSeminars/UpcomingSeminars.style.js